import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {DeButtonComponent, DeModalComponent} from '@docestate/ui-angular';
import {provideTranslocoScope, TranslocoDirective} from '@jsverse/transloco';
import {AppUpdateService} from '../../services/app-update.service';

/** Displays the pending service-worker update and lets the user explicitly apply it. */
@Component({
  selector: 'app-update-notification',
  imports: [DeButtonComponent, DeModalComponent, TranslocoDirective],
  providers: [...provideTranslocoScope('app-update')],
  templateUrl: './app-update-notification.html',
  styleUrl: './app-update-notification.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateNotification {
  private readonly appUpdateService = inject(AppUpdateService);

  protected readonly isUpdateAvailable = this.appUpdateService.isUpdateAvailable;
  protected readonly isUpdating = this.appUpdateService.isUpdating;

  /** Applies the downloaded application version after the user confirms the update. */
  protected onUpdate(): void {
    void this.appUpdateService.activateUpdate();
  }
}
